// extracted by mini-css-extract-plugin
export default {"sidebar":"YTkmUBd1Nkv9tBGsJ2s4"};